<template>
  <div class="interview">
    <Form ref="form" :model="form" :rules="rules" label-position="right" :label-width="80">
      <FormItem label="岗位选择" prop="jobId">
        <Select v-model="form.jobId" @on-change="changeJob">
          <Option v-for="(item, index) in positionList" :value="item.id" :key="index">{{ item.title }}</Option>
        </Select>
      </FormItem>
      <FormItem label="联系电话" prop="mobile">
        <Input v-model="form.mobile" placeholder="联系电话"></Input>
      </FormItem>
      <FormItem label="面试类型" prop="interviewType">
        <RadioGroup v-model="form.interviewType">
          <Radio :label="1">线上面试</Radio>
          <Radio :label="2">现场面试</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="面试地址" v-if="form.interviewType === 2" prop="address">
        <Input v-model="form.address" placeholder="选择地址" @on-focus="getSite" @on-click="getSite" icon="md-locate"></Input>
      </FormItem>
      <FormItem label="面试时间" prop="interviewTime">
        <Date-picker
          :options="sartTimeOptions"
          @on-change="changeDate"
          type="date"
          format="yyyy-MM-dd"
          :clearable="false"
          :value="date"
          placeholder="选择日期和时间"
        ></Date-picker>
        <TimePicker
          :value="time"
          :clearable="false"
          @on-change="changeTime"
          :steps="[1, 15]"
          format="HH:mm"
          placeholder="选择时间"
          style="margin-left: 20px; width: 112px"
        ></TimePicker>
      </FormItem>

      <FormItem label="备注事项" prop="remark">
        <Input class="content-textarea" v-model="form.remark" type="textarea" :autosize="{ minRows: 3, maxRows: 3 }" />
      </FormItem>
      <FormItem>
        <div class="btn">
          <Button @click="cancle" size="default" style="margin-right: 20px" type="primary" ghost>取消</Button>
          <Button @click="handelInterview" size="default" type="primary">确定</Button>
        </div>
      </FormItem>
    </Form>

    <Drawer :transfer="true" :z-index="10000" title="地图" width="500" :closable="true" :mask-closable="false" v-model="oMap">
      <Map @setSite="setSite"></Map>
    </Drawer>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TUIChatEngine, {
  IConversationModel,
  TUIStore,
  StoreName,
  TUIChatService,
  TUIConversationService
} from '@tencentcloud/chat-uikit-engine';
import Map from '@/components/map/map';
import { setScore } from '@/api/data';
export default {
  name: 'interview',
  data() {
    return {
      oMap: false,
      positionList: [],
      timeList: [],
      dateList: [],
      form: {
        jobId: undefined,
        mobile: undefined,
        interviewType: 2,
        latitude: undefined,
        interviewTime: '',
        remark: undefined
      },
      rules: {
        jobId: [{ type: 'number', required: true, message: '岗位不能为空', trigger: 'blur' }],
        mobile: [
          { required: true, message: '联系电话不能为空', trigger: 'blur' },
          { pattern: /^1\d{10}$/, message: '请输入正确的手机号格式', trigger: 'blur' }
        ],
        interviewType: [{ type: 'number', required: true, message: '面试类型不能为空', trigger: 'blur' }],
        address: [{ required: true, message: '地址不能为空', trigger: 'blur' }],
        interviewTime: [{ required: true, message: '时间不能为空', trigger: 'blur' }]
      },
      sartTimeOptions: {
        disabledDate: time => {
          let now = new Date();
          if (time.getTime() + 24 * 3600 * 1000 < now.getTime()) {
            return true;
          }
          return false;
        }
      },
      date: '',
      time: '09:00'
    };
  },
  props: {
    to: {
      type: String,
      default: ''
    },
    info: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  watch: {
    to: {
      immediate: true,
      handler(val) {
        this.form.to = val;
      }
    }
  },
  components: {
    Map
  },
  computed: {
    ...mapState({
      userProfile: state => state.user.userProfile,
      timPrefix: state => state.user.timPrefix,
      firstTalk: state => state.user.firstTalk
    })
  },
  mounted() {
    this.getPositionList();
  },
  methods: {
    changeJob(id) {
      let job = null;
      this.positionList.forEach(item => {
        if (item.id === id) {
          job = item;
        }
      });
      if (!job) {
        return;
      }
      this.$set(this.form, 'latitude', job.latitude);
      this.$set(this.form, 'longitude', job.longitude);
      this.$set(this.form, 'address', job.address);
      let conversation = TUIStore.getConversationModel(TUIStore.getData(StoreName.CONV, 'currentConversationID'));
      console.log(7788888, conversation);
      if (conversation && conversation.type === TUIChatEngine.TYPES.CONV_C2C) {
        this.$set(this.form, 'to', TUIStore.getData(StoreName.CONV, 'currentConversationID').replace('C2C', ''));
      } else {
        this.$set(this.form, 'to', `${this.timPrefix}${this.info.resume ? this.info.resume.userId : this.info.userId}`);
      }
    },
    changeDate(date) {
      this.date = date;
      if (this.time) {
        this.$set(this.form, 'interviewTime', this.date + ' ' + this.time + ':00');
      }
    },
    changeTime(time) {
      this.time = time;
      if (this.date) {
        this.$set(this.form, 'interviewTime', this.date + ' ' + this.time + ':00');
      }
    },
    cancle() {
      this.$refs.form.resetFields();
      this.$emit('cancle');
    },
    handelInterview() {
      if (this.form.interviewType === 1) {
        this.$set(this.form, 'address', '');
      }
      this.$refs.form.validate(res => {
        if (res) {
          this.$Spin.show();
          this.$axios
            .request({
              url: 'front/v1/interview',
              method: 'post',
              data: this.form
            })
            .then(res => {
              this.jobChat(this.form.jobId);
              this.$Spin.hide();
              this.$Message.success('添加成功');
              this.$emit('sent', res.data);
              setTimeout(() => {
                this.$eventBus.$emit('openChat');
                this.firstTalk && setScore('消息-回复');
                TUIChatService.sendCustomMessage({
                  payload: {
                    data: JSON.stringify({
                      // 评价类消息标识字段
                      businessID: 'interview',
                      interview: res.data,
                      text: '发起了一个面试邀请'
                    }),
                    description: '发起了一个面试邀请'
                  }
                });
              }, 500);
              TUIConversationService.switchConversation('C2C' + this.form.to).catch(err => {
                console.log(err);
                this.$Message.error({
                  content: '打开会话失败' + err.message
                });
              });
            })
            .catch(res => {
              this.$Spin.hide();
            });
        }
      });
    },
    jobChat(jobID) {
      this.$axios.request({
        url: 'front/v1/chat',
        method: 'post',
        data: {
          to: parseInt(this.form.to.replace(this.timPrefix, '')),
          jobId: jobID
        }
      });
    },
    getSite() {
      this.oMap = true;
    },
    setSite(e) {
      this.oMap = false;

      this.$set(this.form, 'latitude', e.latlng.lat);
      this.$set(this.form, 'longitude', e.latlng.lng);
      this.$set(this.form, 'address', e.poiaddress);
    },
    getPositionList() {
      this.$axios
        .request({
          url: 'front/v1/job',
          params: {
            pageSize: 100,
            idOrder: 'desc',
            status: 2
          }
        })
        .then(res => {
          this.positionList = res.data.list;
        });
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .ivu-modal {
  width: 400px !important;
}
.date-item {
  margin-bottom: 20px;
  .title {
    text-align: right;
    padding-right: 20px;
  }
  input {
    padding-left: 5px;
  }
}
.btn {
  float: right;
  margin-right: 20px;
}
.interview:after {
  content: '';
  display: block;
  clear: both;
  height: 0;
}
::v-deep .ivu-drawer-wrap {
  z-index: 10000;
}
</style>
